import $ from "jquery";
import React, { memo, useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import * as Common from "../Common";

function Tran_date_change_modal(props) {
    const sid = sessionStorage.getItem("sessionId");
    // const [changedDate, setChangedDate] = useState(new Date(props.changeDateObj?.billdateymd));
    const [changedDate, setChangedDate] = useState(null);

    useEffect(() => {
        setChangedDate(null);
    }, []);

    const handleCloseModal = () => {
        props.setOpenDateChangeModal(false);
    }

    const saveDateChange = () => {
        const today = Common.dateYMD(new Date());
        const d = Common.dateYMD(changedDate);
        props.setOpenDateChangeModal(false);
        if (changedDate == null) {
            props.setMsgBox(true);
            props.setMsgText("Please fill date");
        } else if (d > today) {
            props.setMsgBox(true);
            props.setMsgText(Common.getMessage("MSG0011"));
        } else {
            $(".loader").show();
            console.log("this is me", props.changeDateObj);
            var updatedChangeDateObj = {
                ...props.changeDateObj,
                changedDate: d
            };
            Common.callApi(Common.apiTranChangeDate, [sid, "changedate", JSON.stringify(updatedChangeDateObj)], result => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                props.setMsgBox(true);
                props.setMsgText(resp.msg);
                if (resp.status) {
                    props.fillViewForm(props.changeDateObj.srno, props.changeDateObj.location, props.changeDateObj.type, d);
                }
                setChangedDate(null);
            });
        }
    }

    return (
        <>
            <Modal show={props.openDateChangeModal} centered onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Change Bill Date</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col><b>Bill Date : {props.changeDateObj.billdate}</b></Col>
                    </Row>
                    <Row>
                        <Col className='col-12'>
                            <Form.Group>
                                <Form.Label>Change date to</Form.Label>
                                <DatePicker className="form-control"
                                    selected={changedDate}
                                    onChange={(date) => setChangedDate(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showYearDropdown
                                    showMonthDropdown
                                    useShortMonthInDropdown
                                    dropdownMode="select"
                                    peekNextMonth
                                    customInput={
                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                    }
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button size='sm' variant="secondary" onClick={handleCloseModal}>
                        Close
                    </Button>
                    <Button size='sm' variant="outline-success" onClick={saveDateChange}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default memo(Tran_date_change_modal);
